import useGlobalStore from '@/store/useGlobalStore'
import { useFlags } from 'launchdarkly-react-client-sdk'
import Image from 'next/image'
import T from '../Helpers/Translate'

export const FixedReportIssueButton = () => {
  const {
    app: { marketExceptions, language },
  } = useGlobalStore()

  // TODO: Look into making Launch Darkly type-safe
  const { showReportIssueButton } = useFlags()

  if (!marketExceptions) return null
  if (!marketExceptions.reportIssueButton) return null
  if (!marketExceptions.reportIssueButton.show) return null
  if (!marketExceptions.reportIssueButton.url) return null
  if (!marketExceptions.reportIssueButton.url[language]) return null
  if (!showReportIssueButton) return null

  return (
    <a target="_blank" href={marketExceptions.reportIssueButton.url[language]}>
      <div
        style={{ zIndex: 100 }}
        className="fixed right-5 bottom-5 cursor-pointer rounded-full bg-primary p-5 text-white shadow-lg"
      >
        <span className="flex items-center justify-center space-x-2">
          <Image
            alt="Report Issue"
            height={28}
            width={28}
            src="/icons/report-issue.svg"
          />
          <T>report_issue</T>
        </span>
      </div>
    </a>
  )
}
